import { useScript } from 'usehooks-ts'

export default function useLightbox () {
  return useScript(process.env.REACT_APP_ENV === 'production'
    ? 'https://api.convergepay.com/hosted-payments/PayWithConverge.js'
    : 'https://api.demo.convergepay.com/hosted-payments/PayWithConverge.js')
}
